import { Select } from "antd"
import ArrowBackButton from "../../../../components/button/ArrowBackButton"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import useBuForm from "./useBusinessForm"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const BusinessUnitForm = () => {
    const params = useParams()
    const {
        setListGroupBu, 
        getBuForm, 
        groupBu, 
        putBuForm, 
        postBuForm, 
        onChangeHandler, 
        payload,
        handleSelect,
        handleSelectStatus,
        isSaving,
        status
    } = useBuForm()
    const [isUpdate, setIsUpdate] = useState(false)

    useEffect(() => {
        setListGroupBu()
        if (params.bu_id) {
            setIsUpdate(true)
            getBuForm(params.bu_id)
        }
    }, [params.bu_id, getBuForm, setListGroupBu])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton 
                    title={isUpdate ? "Edit Business Unit" : "Create Business Unit"} 
                    isTwoSection={true}
                />
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    {isUpdate ? "Edit Business Unit" : "Business Unit Information"}
                </h5>

                <form onSubmit={(e) => {
                    isUpdate ? putBuForm(e): postBuForm(e)
                }}>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="mb-4">
                            <label htmlFor="ID" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Business Unit ID <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="ID"
                                className="form-control" 
                                id="ID" 
                                placeholder="Enter Business Unit ID" 
                                onChange={onChangeHandler}
                                value={payload.ID}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>
                        
                        <div className="mb-4">
                            <label htmlFor="Pillar" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Pillar <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="Pillar"
                                className="form-control" 
                                id="Pillar" 
                                placeholder="Enter Pillar" 
                                onChange={onChangeHandler}
                                value={payload.Pillar}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="GroupBusinessUnitId" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Business Unit Group <span style={{color: 'red'}}>*</span>
                            </label>
                            <Select
                                required
                                allowClear
                                size="large"
                                style={{
                                    width: '100%'
                                }}
                                showSearch="true"
                                name="GroupBusinessUnitId"
                                options={groupBu}
                                placeholder="Enter Business Unit Group"
                                onChange={handleSelect}
                                value={payload.GroupBusinessUnitId}
                                fontSize="16px"
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="Status" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Status <span style={{color: 'red'}}>*</span>
                            </label>
                            <Select
                                required
                                allowClear
                                size="large"
                                style={{
                                    width: '100%'
                                }}
                                showSearch="true"
                                name="Status"
                                options={status}
                                placeholder="Enter Status"
                                onChange={handleSelectStatus}
                                value={payload.Status}
                                fontSize="16px"
                            />
                        </div>

                        <div className="mb-0">
                            <label htmlFor="Name" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Business Unit Name <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="Name"
                                className="form-control" 
                                id="Name" 
                                placeholder="Enter Business Unit Name" 
                                onChange={onChangeHandler}
                                value={payload.Name}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Business Unit"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default BusinessUnitForm